// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  stripeKey: 'pk_live_jz2qrKr9Ye82zXYmmIgUdDpR',
  apiUrl: 'https://dev-fapi.trivia.zone/',
  // stripeKey: 'pk_test_51IppIxC6B7URratFlYgRKNJF5Ht4l0UpWW3wD7U98qbkJO348AgdsR0nYFeEinzfo2BTFNa68dD1Sbgz3UuUt2if00dDftl8eC',
  // apiUrl: 'http://preview.triviamatic.com:5000/',
  amazonBaseUrl: 'https://trivia-matic.s3.amazonaws.com/',
  amazonBaseUrlDev: 'https://trivia-matic-dev.s3.amazonaws.com/',
  trebekTriviaUrl: 'https://dev-triapi.trivia.zone/',
  trebekDoActionUrl: 'https://dctapi.trebektrivia.com/cloud/trebek/do-action',
  firebaseConfig: {
    apiKey: "AIzaSyDuZse4XjV-SedTWSp21xxWhaqefJT1N74",
    authDomain: "triviamatic-dev-e3337.firebaseapp.com",
    projectId: "triviamatic-dev-e3337",
    storageBucket: "triviamatic-dev-e3337.appspot.com",
    messagingSenderId: "9264300939",
    appId: "1:9264300939:web:18123bdaa9d848462d658e",
    measurementId: "G-S9X08VWRPD"
  },
  trebekBaseUrl: 'https://admindev.trebektrivia.com/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
